import { ChevronUp, ChevronDown, Trash2, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion, AnimatePresence } from "framer-motion";

/** Generic add/remove/reorder list. children: render fn (item, idx, set) */
export default function RepeaterList({ items = [], onChange, render, makeNew, addLabel = "Add item", testid }) {
  const setItem = (idx, patch) => {
    const next = items.slice();
    next[idx] = { ...next[idx], ...patch };
    onChange(next);
  };
  const removeAt = (idx) => onChange(items.filter((_, i) => i !== idx));
  const move = (idx, dir) => {
    const j = idx + dir;
    if (j < 0 || j >= items.length) return;
    const next = items.slice();
    [next[idx], next[j]] = [next[j], next[idx]];
    onChange(next);
  };
  const add = () => onChange([...(items || []), makeNew ? makeNew() : {}]);

  return (
    <div className="space-y-3">
      <AnimatePresence initial={false}>
        {items.map((it, idx) => (
          <motion.div key={it.id || idx} layout
            initial={{ opacity: 0, y: -6 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.18 }}
            className="rounded-xl border border-slate-200 bg-white p-4">
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1 min-w-0">
                {render(it, idx, (patch) => setItem(idx, patch))}
              </div>
              <div className="flex flex-col gap-1 shrink-0">
                <Button data-testid={testid ? `${testid}-up-${idx}` : undefined} type="button" variant="ghost" size="icon" className="h-8 w-8" disabled={idx === 0} onClick={() => move(idx, -1)}><ChevronUp className="h-4 w-4"/></Button>
                <Button data-testid={testid ? `${testid}-down-${idx}` : undefined} type="button" variant="ghost" size="icon" className="h-8 w-8" disabled={idx === items.length - 1} onClick={() => move(idx, 1)}><ChevronDown className="h-4 w-4"/></Button>
                <Button data-testid={testid ? `${testid}-del-${idx}` : undefined} type="button" variant="ghost" size="icon" className="h-8 w-8 text-red-500 hover:text-red-600" onClick={() => removeAt(idx)}><Trash2 className="h-4 w-4"/></Button>
              </div>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
      <Button data-testid={testid ? `${testid}-add` : undefined} type="button" variant="outline" onClick={add} className="rounded-full"><Plus className="h-4 w-4 mr-2"/>{addLabel}</Button>
    </div>
  );
}
